import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { AuthenticationService, DealerService, SpinnerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { Subscription } from 'rxjs/Subscription';


@Component({
    templateUrl: 'client-subscription-dealers.component.html',
})
export class ClientSubscriptionDealersComponent {
    dealerLegacySources:any;
    legacySource:any;
    dealers: any[];
    dealerCols: any;
    customMessage: any;
    currentUser: any;
    searchText: string;
    topMenuBar: boolean;
    public syncTopMenuClick: boolean = true;
    DealerGuid: string;
    show: boolean = false;
    toggleClass: string = "fa fa-angle-double-down";
    pager: any;
    NoofPages: number=10;
    mode: any = 'desc';
    sortValue: any = 'updateddt';
    excelDealers: any;
    downloadExcelFlag: any = 0;
    selectedvalues:any;
    private subscription: Subscription = new Subscription();
    ClientSubscriptionGuid: any;
    displaySubDlrDltDialog: boolean = false;
    successMessage: string;
    isSuccessMessage: boolean = true;
    MasterSelectedValues: any;
    ClientName:any;
    SubscriptionName:any;
   
    constructor(private dealerService: DealerService,
        private router: Router,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { 
            authenticationService.topMenuBar.subscribe(value => {
                this.syncTopMenuClick = !value;
            });
        }
    ngOnInit() {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.searchText = "";
        this.subscription = this.route.params.subscribe(
            params => {
                this.ClientSubscriptionGuid = params['guid'];
            }
        );
        this.getDealer(1);
    }
    bindDealerInfo() {
        this.getDealer(1);
    }
    sortChange(){
        if(this.mode != undefined && this.sortValue != undefined){
            this.bindDealerInfo();
        }
    }
    getDealer(page) {
        this.spinnerService.start();
        this.dealerService.getSubscriptionDealers(this.ClientSubscriptionGuid,this.searchText,this.mode,this.sortValue,this.NoofPages,page,this.downloadExcelFlag).pipe(first()).subscribe(dealers => {
            this.http.get('assets/data/dealer-header.json').subscribe(results => {
                this.dealerCols = results;
                if(this.downloadExcelFlag == 1){
                    this.excelDealers = dealers;
                    this.excelDealers.forEach(function(x){
                        x.OEMCode = x.OemCode;
                        delete x.CreatedBy;                
                        delete x.ListDealerMapping;
                        delete x.ListLastServiceDates;
                        delete x.DealerId;
                        delete x.SearchText;
                        delete x.UpdatedBy;
                        delete x.DpsClientId;
                        delete x.OcClientId;
                        delete x.AlClientId;
                        delete x.OemCode;                        
                        delete x.PageSize;
                        delete x.PageNo;
                        delete x.SalesforceID;
                        delete x.ListLastSaleDates;
                        delete x.DeleteComments;
                        delete x.DataSourceId;
                        delete x.Mode;
                        delete x.SortValue;
                        delete x.OpcodeProcessedDate;
                        delete x.DealerMappingId;
                        delete x.DealerGuid;
                        delete x.ParentDealerId;
                        delete x.TimeZone;
                        delete x.IsOpcodeRequired;
                        delete x.DealerCount;
                        delete x.EffectiveDate;
                        delete x.DealerMappingDeleteFlag;
                        delete x.DealerGuids;
                        delete x.SourceOfDealer;
                        delete x.LastSaleDate;
                        delete x.LastServiceDate;
                        delete x.SourceType;
                        delete x.TotalRecordCount;
                        delete x.DealerSource;
                        delete x.ClientSubscriptionGuid;
                    });
                    this.exportExcel();
                    
                }else{
                    if (dealers.length > 0) {
                        this.ClientName = dealers[0].ClientName;
                        this.SubscriptionName = dealers[0].SubscriptionName;
                        this.pager = this.dealerService.getPager(dealers[0].TotalRecordCount, page, this.NoofPages);
                        this.dealers = dealers;
                    }
                    else {
                        this.dealers = [];
                        this.customMessage = "No recors found";
                    }
                }
                this.downloadExcelFlag = 0;
                this.spinnerService.stop();
            });
        }),
        error => {
            this.spinnerService.stop();
        };
    }
    setPage(page: number, campaignMebId) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        this.getDealer(page)
    }
    onChange($event, page) {
        this.getDealer(page);
    }
    onClickOutside(event) {
        this.authenticationService.dynamicOutClick.next("true");
    }
    backtogrid(){
        this.router.navigate(['/subscriptions/managesubscriptions']);
    }
  
    searchClick(show){
        if(show == false){
            this.toggleClass = 'fa fa-angle-double-down';
        }else{
            this.toggleClass = 'fa fa-angle-double-up';
        }
    }
 
    deleteSubscribedDealers(){
        this.displaySubDlrDltDialog = true;
    }
    ConfirmDelete(){
        this.spinnerService.start();
        //this.displaySubDlrDltDialog = false;
        this.MasterSelectedValues = this.selectedvalues;
        var dealerGuids = "";
        this.selectedvalues.forEach(function(x){
            dealerGuids += x.DealerGuid+',';
            
        });
        this.dealers;
        this.dealerService.deleteSubscribedDealers(this.ClientSubscriptionGuid,dealerGuids,this.currentUser.userName).pipe(first()).subscribe(data => {
            this.isSuccessMessage = false;
            this.displaySubDlrDltDialog = false;
            this.successMessage = 'Deleted successfully';
            setInterval(() => {
                this.isSuccessMessage = true;
                window.location.reload(true);
            }, 1000);
            
            this.spinnerService.stop();
        });
    }
    No(){
        this.displaySubDlrDltDialog = false;
    }
    downloadexcel(downloadExcelFlag){
        this.downloadExcelFlag = downloadExcelFlag;
        this.getDealer(1);
        this.spinnerService.start();
    }
    exportExcel() {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.excelDealers);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "subscribed_dealers");
        });
    }
    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        });
        this.spinnerService.stop();
    }
}